import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardImage, MatCardTitle } from '@angular/material/card';
import { RouterLink } from '@angular/router';

import { NewsItemDto } from '../../api';
import { NewsItemsService } from '../../api/api/news-items.service';
import { ErrorService } from '../../shared/error.service';

@Component({
  selector: 'app-home-news',
  imports: [MatCard, MatCardTitle, MatCardHeader, MatCardContent, MatCardImage, RouterLink],
  templateUrl: './home-news.component.html',
  styleUrl: './home-news.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeNewsComponent {
  loading = signal(true);
  newsItems = signal<NewsItemDto[]>([]);
  private service = inject(NewsItemsService);
  private errorService = inject(ErrorService);

  constructor() {
    this.service.listNewsItems().subscribe({
      next: (newsItems) => {
        this.newsItems.set(newsItems);
        this.loading.set(false);
      },
      error: (error) => {
        this.loading.set(false);
        this.errorService.showErrorDialog(this.errorService.getMessage(error));
      },
    });
  }
}
